import { zodResolver } from '@hookform/resolvers/zod'
import Box from '@repo/ui/box'
import InnerBox from '@repo/ui/inner-box'
import { useForm } from 'react-hook-form'

import { TripBookingGuidelineInput } from '../../../lib/types/models/trip-booking/trip-booking-guideline-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import Form, { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'
import { tripBookingGuidelinesSchema } from './utils'

const TripBookingGuidlineForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<TripBookingGuidelineInput>) => {
  const form = useForm<TripBookingGuidelineInput>({
    resolver: zodResolver(tripBookingGuidelinesSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form form={form}>
      <Box>
        <form
          onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
          className="flex flex-col gap-4"
        >
          <InnerBox title="Consignes" className="rounded-xl">
            <div className="flex flex-col gap-3">
              <FormField
                control={form.control}
                name="label"
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormControl>
                      <ControlledInput {...field} label="Type" type="text" required />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="description"
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormControl>
                      <ControlledInput
                        {...field}
                        label="Description"
                        type="textarea"
                        rows={20}
                        required
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
            </div>
          </InnerBox>

          <ValidationButtons {...validationButtonProps} />
        </form>
      </Box>
    </Form>
  )
}

export default TripBookingGuidlineForm
